"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Piece_vue_1 = __importDefault(require("~components/Piece.vue"));
const store_1 = require("~/front/store");
const Board_1 = require("~/chess/Board");
const jquery_1 = __importDefault(require("jquery"));
let Board = class Board extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.game = store_1.store.state.game;
        this.letters = [...Board_1.Board.letters];
        this.numbers = [...Board_1.Board.numbers].reverse(); // Spread operator to avoid reference change
    }
    onGameChange() {
        this.renderBoard();
    }
    mounted() {
        this.renderBoard();
    }
    renderBoard() {
        this.cleanBoard();
        for (const position in this.game.board) {
            const piece = this.game.board[position];
            if (piece !== undefined) {
                const pieceComponent = new Piece_vue_1.default({
                    data: { piece }
                });
                jquery_1.default(`#${position}`).html('<div id="z"></div>');
                pieceComponent.$mount('#z');
            }
        }
    }
    cleanBoard() {
        jquery_1.default('.piece').remove();
    }
};
__decorate([
    vue_property_decorator_1.Watch('game')
], Board.prototype, "onGameChange", null);
Board = __decorate([
    vue_property_decorator_1.Component
], Board);
exports.default = Board;
